import { Typography } from "@/core/components/ui/typography";

// The field primitives style their invalid state. The step renders each message in one
// consistent place. Errors belong on the field they are about, not in a banner that
// repeats what a field already said.
export const FieldError = ({ message }: { message?: string }) =>
  message ? (
    <Typography
      variant="captionW1"
      // Announced when it appears: a customer using a screen reader has to hear why the
      // submit did not go through.
      role="alert"
      className="text-destructive"
    >
      {message}
    </Typography>
  ) : null;
